module.exports = __webpack_public_path__ + "static/img/north van napa logo.e2a3ea5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/autoshoplogo/north van napa logo.jpg
// module id = nRMS
// module chunks = 0